export const DETAIL_PLAN = 'plan';
